import { Model, attr, fk } from 'redux-orm';

import ActionTypes from '../constants/ActionTypes';

export default class extends Model {
  static modelName = 'CustomerGroup';

  static fields = {
    id: attr(),
    name: attr(),
    description: attr(),
    color: attr(),
    isWholesale: attr(),
    businessId: fk({
      to: 'Business',
      as: 'business',
      relatedName: 'customerGroups',
    }),
  };

  static reducer({ type, payload }, CustomerGroup) {
    switch (type) {
      case ActionTypes.SOCKET_RECONNECT_HANDLE:
        CustomerGroup.all().delete();

        payload.customerGroups.forEach((customerGroup) => {
          CustomerGroup.upsert(customerGroup);
        });

        break;
      case ActionTypes.CORE_INITIALIZE:
      case ActionTypes.BUSINESS_CREATE__SUCCESS:
      case ActionTypes.BUSINESS_CREATE_HANDLE:
        payload.customerGroups.forEach((customerGroup) => {
          CustomerGroup.upsert(customerGroup);
        });

        break;
      case ActionTypes.CUSTOMER_GROUP_CREATE:
      case ActionTypes.CUSTOMER_GROUP_CREATE_HANDLE:
      case ActionTypes.CUSTOMER_GROUP_UPDATE__SUCCESS:
      case ActionTypes.CUSTOMER_GROUP_UPDATE_HANDLE:
        CustomerGroup.upsert(payload.customerGroup);

        break;
      case ActionTypes.CUSTOMER_GROUP_CREATE__SUCCESS:
        CustomerGroup.withId(payload.localId).delete();
        CustomerGroup.upsert(payload.customerGroup);

        break;
      // case ActionTypes.CUSTOMER_GROUP_CREATE_HANDLE:
      //   CustomerGroup.upsert(payload.customerGroup);

      //   if (payload.customerGroups) {
      //     payload.customerGroups.forEach((customerGroup) => {
      //       CustomerGroup.upsert(customerGroup);
      //     });
      //   }

      //   break;
      case ActionTypes.CUSTOMER_GROUP_DELETE:
        CustomerGroup.withId(payload.id).delete();

        break;
      case ActionTypes.CUSTOMER_GROUP_DELETE__SUCCESS:
      case ActionTypes.CUSTOMER_GROUP_DELETE_HANDLE: {
        const customerGroupModel = CustomerGroup.withId(payload.customerGroup.id);

        if (customerGroupModel) {
          customerGroupModel.delete();
        }

        break;
      }
      default:
    }
  }
}
